<template>
    <layout>
        <transition name="fade">
            <router-view></router-view>
        </transition>
    </layout>
</template>

<script>
    import Layout from './Layout.vue';

    export default {

        name: 'full',

        components: {Layout}

    };
</script>



// WEBPACK FOOTER //
// src/containers/Full.vue